import { render, staticRenderFns } from "./index.vue?vue&type=template&id=963b1822&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./index.vue?vue&type=style&index=0&id=963b1822&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "963b1822",
  null
  ,true
)

export default component.exports